import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import {
  Row,
  Col,
  Tabs,
  Input,
  Button,
  Space,
  Menu,
  Dropdown,
  Radio,
  Drawer,
  Divider,
  Pagination,
} from "antd";
import "./JobListing.css";
import JobCard from "../../components/JobCard/JobCard";
import {
  getJobListing,
  jobListingRESET,
  getJobListingDraft,
  jobListingDraftRESET,
  getJobCounts,
  getJobListingResult,
  getdraftListInit,
  keySearchMyGigsLocation,
  fetchMyGigsKeySearchSkills,
  GetMyGigFilters,
} from "../../redux/actions";
import { useDispatch, useSelector } from "react-redux";
import { useLocation } from "react-router-dom";
import Loader from "../../components/Loading/Loader";
import { getImageByStateCode } from "../CompanyProfile/components/cloudinary";
import candidate_img from "../../assets/img/becomeACandidate.png";
import {
  PropertySafetyFilled,
  SearchOutlined,
  CloseOutlined,
} from "@ant-design/icons";
import { BsSortUpAlt, BsFunnel } from "react-icons/bs";
import { DownOutlined } from "@ant-design/icons";
import emptyjobs from "../../assets/img/Emptyjobs.png";
import history from "../../routes/history";
import TopAlert from "../../components/TopNotification/TopAlert";
import closeIcon from "../../assets/icons/clarity_window-closeLine.svg";
import { debounce, getDeepCopy } from "../../shared/helpers";
import { FiChevronDown } from "react-icons/fi";
import downArrow from "../../assets/icons/downArrow.png";
import emptyresult from "../../assets/img/cuate@2x.png";
import AllGigsFilter from "../SearchSkillListing/components/AllGigs/AllGigsFilter";
import _ from "lodash";
import {
  ApolloClient,
  ApolloProvider,
  InMemoryCache,
  useLazyQuery,
} from "@apollo/client";
import { GIGS_QUERY } from "../../components/PlaceBidModal/gigsQuery";
import { HttpLink } from "apollo-link-http";
import { setContext } from "@apollo/client/link/context";
import { types } from "../../redux/action-types";

const DEFAULT_FILTER_VALUES = {
  location: [],
  CityId: [],
  RegionId: [],
  CountryId: [],
  city: null,
  region: [],
  state: [],
  all: "",
  skillListing_type: null,
  budgetType: null,
  ExperienceLevel: [],
  budgetMin: null,
  budgetMax: null,
  NearBy: null,
  hidePrevious: null,
  ProfessionCode: null,
  isPrivateGig: false,
  visa: [],
  visaName: [],
  company: null,
  industry: null,
  skill: [],
  SkillsId: [],
};
function JobListing() {
  const { TabPane } = Tabs;
  const dispatch = useDispatch();

  const loading = useSelector((state) => state.manageJobsReducer.loading);
  const jobs = useSelector((state) => state.manageJobsReducer.jobs);
  const MostRecentJobs = useSelector(
    (state) => state.manageJobsReducer.MostRecentJob.publishedGigs
  );
  const MostRecentDraft = useSelector(
    (state) => state.manageDraftJobsReducer.DraftList
  );
  const LoadingDraft = useSelector((state) => state.deleteJobReducer.loading);
  const MostRecentDelete = useSelector(
    (state) => state.deleteJobReducer.response
  );
  const counts = useSelector((state) => state.manageJobsReducer.counts);
  const Draftjobs = useSelector((state) => state.manageDraftJobsReducer.jobs);
  const draftLoading = useSelector(
    (state) => state.manageDraftJobsReducer.loading
  );

  const deljobsuccess = useSelector(
    (state) => state.manageJobsReducer.del_success
  );
  // const professionCode = useSelector(state => state.profileReducer.user.profile.ProfessionCode)
  let userProfile = JSON.parse(localStorage.getItem("userProfile"));

  const expiry_response = useSelector(
    (state) => state.manageJobsReducer.expiry_success
  );
  const extended_expiry_id = useSelector(
    (state) => state.updateGigReducer.response._id
  );
  const jobReducerState = useSelector((state) => state.manageJobsReducer);

  const delete_job_response = useSelector(
    (state) => state.manageJobsReducer.response
  );
  const authTokenValue = useSelector(
    (state) => state.authReducer.user.authToken
  );

  // const [expired, setExpired] = useState(expiry_response ? false : expiry_response);

  const location = useLocation();
  const [searchPublish, setsearchPublish] = useState([]);
  const [searchPublishGigs, setSearchPublishGigs] = useState([]);
  const [searchDraft, setsearchDraft] = useState([]);
  const [searchExpired, setsearchExpired] = useState([]);
  const [searchDeleted, setsearchDeleted] = useState([]);
  const [inputSearch, setInputSearch] = useState("");
  const [DraftInputSearch, setDraftInputSearch] = useState("");
  const [sorttype, setsorttype] = useState(
    location.search != null
      ? location.search.split("qeury_sort_param=")[1]
      : "most_recent"
  );

  const [tabType, settabType] = useState("Published");
  const [dimensions, setDimensions] = useState(window.innerWidth);
  const [windowDimensions, setWindowDimensions] = useState(
    getWindowDimensions()
  );

  const [jobStatusRadioValue, setJobStatusRadioValue] = useState(1);
  const [sortTypeText, setsortTypeText] = useState("Most recent");

  const [visibleStatusDrawer, setVisibleStatusDrawer] = React.useState();
  const [visibleDrawer, setVisibleDrawer] = React.useState(false);
  // const [jobStatusFilterValue, setJobStatusFilterValue] = useState(location.search.split('jobStatusFilter=')[1]!=undefined ? parseInt(location.search.split('jobStatusFilter=')[1]):1);
  const [jobStatusFilterValue, setJobStatusFilterValue] = useState(1);

  const [publishedJobs, setPublishedJobs] = useState([]);
  const [expiredJobs, setExpiredJobs] = useState([]);
  const [deletedJobs, setDeletedJobs] = useState([]);

  const [jobsWithOnlyCandidates, setJobsWithOnlyCandidates] = useState([]);
  const [filteredJobsCountMobile, setFilteredJobsCountMobile] = useState(0);
  const [jobsWithOnlyCandidatesValue, setJobsWithOnlyCandidatesValue] =
    useState(false);

  const [appliedFiltersCount, setAppliedFiltersCount] = useState(0);
  const [currentPage, setCurrentPage] = useState(1);
  const [currentPageDraft, setCurrentPageDraft] = useState(1);
  const pageSize = 21;
  // const [GigType, setGigType] = useState(location.search.split('jobStatusFilter=')[1] ?location.search.split('jobStatusFilter=')[1] :"all");
  const [GigType, setGigType] = useState(false);
  const [searchFilters, setSearchFilters] = useState({
    DEFAULT_FILTER_VALUES,
  });
  const [publishedCount, setPublishedCount] = useState();
  const [expiredCount, setExpiredCount] = useState();
  const [deletedCount, setDeletedCount] = useState();
  const [closedCount, setClosedCount] = useState();
  const [allDrafts, setAllDrafts] = useState(null);

  const [getGigs, { loading: loadingGigs, error, data }] = useLazyQuery(
    GIGS_QUERY,
    { fetchPolicy: "no-cache", nextFetchPolicy: "no-cache" }
  );
  useEffect(() => {
    setDimensions(window.innerWidth);
  }, [window.innerWidth]);

  useEffect(() => {
    if (data && data?.gigs?.data?.length !== 0) {
      const _data = getDeepCopy(data?.gigs?.data);
      let uniqueJobs = {};
      let filteredJobs = _data.filter((obj) => {
        if (!uniqueJobs[obj._id]) {
          uniqueJobs[obj._id] = true;
          return true;
        }
        return false;
      });
      setSearchPublishGigs(getDeepCopy(filteredJobs));
    } else setSearchPublishGigs([]);
  }, [data?.gigs?.data]);
  const updateDeletedGig = (jobId) => {
    const deletedStatus = {
      JobOrderStatusCode: "P",
      JobOrderStatusId: 3,
      JobOrderStatusName: "Deleted",
    };

    try {
      const _searchPublishGigsCopy = getDeepCopy(searchPublishGigs);
      const ind = _searchPublishGigsCopy.findIndex(
        (el) => el.JobOrderId == jobId
      );
      if (ind >= 0) {
        const obj = _searchPublishGigsCopy[ind];
        _searchPublishGigsCopy[ind] = {
          ...obj,
          JobOrderStatuses: { ...obj.JobOrderStatuses, ...deletedStatus },
        };
        setSearchPublishGigs(_searchPublishGigsCopy);
        dispatch({ type: types.DELETE_JOB_RESET });
      }
      // const gigsDictionary = searchPublishGigs.reduce((acc, curr) => {
      //   return {...acc,[curr.JobOrderId]:curr}
      // },{})
      // gigsDictionary[jobId] =
    } catch (error) {
      console.log("error 402", error);
    }
  };

  useEffect(() => {
    if (delete_job_response && delete_job_response.length != 0) {
      if (
        delete_job_response.updatedGig &&
        delete_job_response.updatedGig.JobOrderId
      ) {
        updateDeletedGig(delete_job_response.updatedGig.JobOrderId);
        // handleApplyFilter({ ...(searchFilters || {}), currentPage });
      } else {
        console.log("updatedGig or JobOrderId is undefined");
      }
    }
  }, [delete_job_response]);

  useEffect(() => {
    function handleResize() {
      setWindowDimensions(getWindowDimensions());
    }
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  useEffect(() => {
    if (location.search?.length > 0) {
      if (location.search.split("jobStatusFilter=")[1] != undefined) {
        setJobStatusFilterValue(
          parseInt(location.search.split("jobStatusFilter=")[1])
        );
        setAppliedFiltersCount(1);
      }

      if (jobs?.length !== 0) {
        if (location.search.split("all_gigs_page=")[1]) {
          setCurrentPage(parseInt(location.search.split("all_gigs_page=")[1]));
        }
        if (location.search.split("draft_gigs_page=")[1]) {
          setCurrentPageDraft(
            parseInt(location.search.split("draft_gigs_page=")[1])
          );
        }
      }
    } else {
      setJobStatusFilterValue(1);
      setCurrentPage(1);
      setCurrentPageDraft(1);
    }
  }, [location.search, jobs]);

  function getWindowDimensions() {
    const { innerWidth: width, innerHeight: height } = window;
    return {
      width,
      height,
    };
  }

  function handleTabChange(key) {
    settabType(key);
    setSearchFilters(DEFAULT_FILTER_VALUES);
    updateFilters(DEFAULT_FILTER_VALUES);
    if (key == "Draft") getDrafts();
    else handleApplyFilter(DEFAULT_FILTER_VALUES);
  }

  const getAbsParams = () => {
    return userProfile?.IsPrivateEmployer
      ? {
          isAbsGigs: true,
          companyNames: userProfile?.Profiles?.CompanyName
            ? [userProfile?.Profiles?.CompanyName]
            : undefined,
        }
      : {
          MygigsProfileId:
            userProfile?.MasterAccountId || userProfile?.AccountId,
        };
  };

  const getDrafts = (search = DraftInputSearch, page = currentPageDraft) => {
    getGigs({
      variables: {
        all: search,
        isPrivateGig: false,
        MygigsProfileId: userProfile?.MasterAccountId || userProfile?.AccountId,
        _page: page || "1",
        _perPage: pageSize,
        _sort: "MOST_RECENT",
        JobOrderStatusName: "Draft",
        // ...(getAbsParams() || {}),
      },
    });
  };

  useEffect(() => {
    if (location.search != null) {
      if (
        location.search.split("qeury_sort_param=")[1]?.split("&")[0] ==
        "most_recent"
      ) {
        setsortTypeText("Most recent");
      } else if (
        location.search.split("qeury_sort_param=")[1]?.split("&")[0] ==
        "upcoming_expiry"
      ) {
        setsortTypeText("Upcoming expiry");
      } else if (location.search.split("qeury_sort_param=")[1] == "HI_LOW") {
        setsortTypeText("Candidate high to low");
      } else if (location.search.split("qeury_sort_param=")[1] == "LOW_HIGH") {
        setsortTypeText("Candidate low to high");
      }
    }
  }, []);

  useEffect(() => {
    dispatch(jobListingRESET());
    dispatch(jobListingDraftRESET());
    getGigs({
      variables: {
        all: "",
        isPrivateGig: false,
        MygigsProfileId:userProfile?.MasterAccountId || userProfile?.AccountId,
        _page: currentPage || "1",
        _perPage: pageSize,
        _sort: "MOST_RECENT",
        // ...(getAbsParams() || {}),
      },
    });
  }, []);

  useEffect(() => {
    dispatch(
      getJobListingResult({
        sorttype: "most_recent",
        currentPage: currentPage,
        pageSize: 3,
        gigType: GigType,
      })
    );
  }, []);

  useEffect(() => {
    // debounce(
    //   dispatch(
    //     getJobCounts({
    //       // inputSearch: inputSearch == " " ? "$" : inputSearch
    //     })
    //   )
    // );

    debounce(
      dispatch(
        getJobListing({
          sorttype: sorttype,
          currentPage: currentPage,
          pageSize: pageSize,
          gigType: GigType,
          inputSearch: inputSearch == " " ? "$" : inputSearch,
        })
      )
    );
  }, [
    sorttype,
    deljobsuccess,
    expiry_response,
    currentPage,
    GigType,
    inputSearch,
  ]);

  useEffect(() => {
    if (authTokenValue) {
      // debounce(
      //   dispatch(
      //     getJobCounts({
      //       inputSearch: inputSearch == " " ? "$" : inputSearch,
      //     })
      //   )
      // );

      debounce(
        dispatch(
          getJobListing({
            sorttype: sorttype,
            currentPage: currentPage,
            pageSize: pageSize,
            gigType: GigType,
            inputSearch: inputSearch == " " ? "$" : inputSearch,
          })
        )
      );
    }
  }, [
    sorttype,
    deljobsuccess,
    expiry_response,
    currentPage,
    GigType,
    inputSearch,
  ]);

  useEffect(() => {
    dispatch(
      getJobListingDraft({
        sorttype: sorttype,
        currentPage: currentPageDraft,
        pageSize: pageSize,
        inputSearch: DraftInputSearch == " " ? "$" : DraftInputSearch,
      })
    );
  }, [currentPageDraft, DraftInputSearch]);

  useEffect(() => {
    if (MostRecentDelete?.status === 200) {
      dispatch(
        getJobListingDraft({
          sorttype: sorttype,
          currentPage: currentPageDraft,
          pageSize: pageSize,
          inputSearch: "$",
        })
      );
      dispatch(
        getdraftListInit({
          sorttype: sorttype,
          currentPage: currentPageDraft,
          pageSize: pageSize,
          inputSearch: "$",
        })
      );
    }
  }, [MostRecentDelete?.updatedGig?._id]);

  useEffect(() => {
    dispatch(
      getdraftListInit({
        sorttype: sorttype,
        currentPage: currentPageDraft,
        pageSize: pageSize,
        inputSearch: "$",
      })
    );
  }, [currentPageDraft]);

  useEffect(() => {
    setsearchDraft(Draftjobs?.draftGigs);
    if (Draftjobs?.length !== 0) {
      // setAllDrafts(counts?.totalCount[0]?.draft ? counts?.totalCount[0]?.draft : 0);
    }
  }, [Draftjobs]);

  // useEffect(()=>{
  //   if (jobs?.length !== 0) {
  //   var filterPublished = jobs?.publishedGigs?.filter((job) => !(new Date(`${job.ExpiryDate}`) < new Date()) && (job.JobOrderStatuses.JobOrderStatusName == 'Published'))
  //     var filterDeleted = jobs?.publishedGigs?.filter((job) => job.JobOrderStatuses.JobOrderStatusName == 'Deleted')
  //     // var filterExpired = jobs.publishedGigs.filter((job) => job.JobOrderStatusName == 'Expired')
  //     var filterExpired = jobs?.publishedGigs?.filter((job) => new Date(`${job.ExpiryDate}`) < new Date() && !(job.JobOrderStatuses.JobOrderStatusName == 'Deleted'))
  //     var filterClosed = jobs?.publishedGigs?.filter((job) => !(job.JobOrderStatuses.JobOrderStatusName == 'Deleted') && !(job.JobOrderStatuses.JobOrderStatusName == 'Expired'))
  //     // new Date(`${job.ExpiryDate}`) < new Date() &&
  //     var filterJobsWithOnlyCandidates = jobs.publishedGigs.filter((job) => job.status[3].count != 0)

  //   if(location.search != ""){
  //     const JobFilterStatus = location.search.split('jobStatusFilter=')[1];
  //     setGigType(JobFilterStatus)
  //   }}
  // },[jobs])

  useEffect(() => {
    if (jobs?.length !== 0) {
      if (sorttype == "upcoming_expiry") {
        let sortedJobs = jobs?.publishedGigs.sort((p1, p2) =>
          p1.JobOrderStatusName == "Deleted"
            ? 0
            : new Date(`${p1.ExpiryDate}`) < new Date()
            ? -1
            : 1
        );
        setsearchPublish(sortedJobs);
      } else {
        setsearchPublish(jobs?.publishedGigs);
      }

      setsearchExpired(jobs.expiredGigs);
      setsearchDeleted(jobs.deletedGigs);
      setExpiredCount(
        counts?.totalCount && counts?.totalCount[0]?.expired
          ? counts?.totalCount[0]?.expired
          : 0
      );
      setDeletedCount(
        counts?.totalCount && counts?.totalCount[0]?.deleted
          ? counts?.totalCount[0]?.deleted
          : 0
      );
      setClosedCount(
        counts?.totalCount && counts?.totalCount[0]?.closed
          ? counts?.totalCount[0]?.closed
          : 0
      );
      setPublishedCount(
        counts?.totalCount && counts?.totalCount[0]?.published
          ? counts?.totalCount[0]?.published
          : 0
      );
      if (allDrafts == null)
        setAllDrafts(
          counts?.totalCount && counts?.totalCount[0]?.draft
            ? counts?.totalCount[0]?.draft
            : null || null
        );
    }
  }, [counts, jobs]);

  useEffect(() => {
    if (jobs?.length !== 0) {
      let JobFilterStatus;
      if (location.search != "") {
        JobFilterStatus = parseInt(
          location.search.split("jobStatusFilter=")[1]
        );
        // setGigType(JobFilterStatus)
      }
      var filterPublished = jobs.publishedGigs.filter(
        (job) =>
          !(new Date(`${job.ExpiryDate}`) < new Date()) &&
          job.JobOrderStatuses.JobOrderStatusName == "Published"
      );
      var filterDeleted = jobs.publishedGigs.filter(
        (job) => job.JobOrderStatuses.JobOrderStatusName == "Deleted"
      );
      // var filterExpired = jobs.publishedGigs.filter((job) => job.JobOrderStatusName == 'Expired')
      var filterExpired = jobs.publishedGigs.filter(
        (job) =>
          new Date(`${job.ExpiryDate}`) < new Date() &&
          !(job.JobOrderStatuses.JobOrderStatusName == "Deleted")
      );
      var filterClosed = jobs.publishedGigs.filter(
        (job) =>
          !(job.JobOrderStatuses.JobOrderStatusName == "Deleted") &&
          !(job.JobOrderStatuses.JobOrderStatusName == "Expired")
      );
      var filterJobsWithOnlyCandidates = jobs?.publishedGigs?.filter(
        (job) => job?.status?.[3]?.count != 0
      );

      setPublishedJobs(filterPublished);
      setDeletedJobs(filterDeleted);
      setExpiredJobs(filterExpired);
      setJobsWithOnlyCandidates(filterJobsWithOnlyCandidates);

      if (jobStatusFilterValue == 1) {
        setsearchPublish(jobs.publishedGigs);
        setFilteredJobsCountMobile(jobs.publishedGigs);
        setGigType("all");
      } else if (jobStatusFilterValue == 2) {
        setsearchPublish(filterPublished);
        setFilteredJobsCountMobile(filterPublished?.length);
        setGigType("Published");
      } else if (jobStatusFilterValue == 3) {
        setsearchPublish(filterExpired);
        setFilteredJobsCountMobile(filterExpired?.length);
        setGigType("expired");
      } else if (jobStatusFilterValue == 4) {
        setsearchPublish(filterDeleted);
        setFilteredJobsCountMobile(filterDeleted?.length);
        setGigType("deleted");
      } else if (jobStatusFilterValue == 5) {
        setsearchPublish(filterClosed);
        setFilteredJobsCountMobile(filterClosed?.length);
        setGigType("closed");
      } else {
        setsearchPublish(filterJobsWithOnlyCandidates);
        setFilteredJobsCountMobile(filterJobsWithOnlyCandidates?.length);
        setAppliedFiltersCount(1);
      }
    }
  }, [jobs, location.search]);

  const addQuery = (key, value) => {
    let searchParams = new URLSearchParams(window.location.search);
    searchParams.set(key, value);
    history.push({
      search: searchParams.toString(),
    });
  };

  const removeQuery = (key) => {
    let searchParams = new URLSearchParams(window.location.search);
    searchParams.delete(key);
    history.push({
      search: searchParams.toString(),
    });
  };

  const onClick = ({ key }) => {
    removeQuery("qeury_sort_param");
    if (key == "most_recent") {
      setsorttype("most_recent");
      setsortTypeText("Most recent");
      addQuery("qeury_sort_param", "most_recent");
    } else if (key == "upcoming_expiry") {
      setsorttype("upcoming_expiry");
      setsortTypeText("Upcoming expiry");
      addQuery("qeury_sort_param", "upcoming_expiry");
    } else if (key == "candidate_high_to_low") {
      setsorttype("HI_LOW");
      setsortTypeText("Candidate high to low");
      addQuery("qeury_sort_param", "HI_LOW");
    } else if (key == "candidate_low_to_high") {
      setsorttype("LOW_HIGH");
      setsortTypeText("Candidate low to high");
      addQuery("qeury_sort_param", "LOW_HIGH");
    }
  };
  const searchHandler = (searchText) => {
    removeQuery("all_gigs_page");
    setInputSearch(searchText);
    setCurrentPage(1);
    handleSearch(searchText);
  };

  const searchDraftHandler = (searchText) => {
    removeQuery("draft_gigs_page");
    setDraftInputSearch(searchText);
    setCurrentPageDraft(1);
    getDrafts(searchText, 1);
  };

  const postgigs = (
    <>
      <div className="jobListing-post-gigs-button">
        <button
          className={
            dimensions > 769 ? "joblisting-btn" : "joblisting-btn-mobile"
          }
          onClick={() => history.push("/postjob")}
        >
          + &nbsp;Post a gig
        </button>
      </div>
    </>
  );

  const onChangeJobStatusFilter = (e) => {
    setJobStatusFilterValue(e.target.value);
  };

  const onChangeJobStatusRadio = (e) => {
    setJobStatusRadioValue(e.target.value);
  };

  const applyFilter = () => {
    removeQuery("jobStatusFilter");
    removeQuery("all_gigs_page");
    setVisibleDrawer(false);
    if (jobStatusFilterValue == 1) {
      setGigType("all");
      // setsearchPublish(jobs.publishedGigs)
      // setFilteredJobsCountMobile(jobs.publishedGigs?.length)
    } else if (jobStatusFilterValue == 2) {
      setGigType("Published");
      // setsearchPublish(publishedJobs)
      // setFilteredJobsCountMobile(publishedJobs?.length)

      setAppliedFiltersCount(1);
    } else if (jobStatusFilterValue == 3) {
      setGigType("expired");
      // setsearchPublish(expiredJobs)
      // setFilteredJobsCountMobile(expiredJobs?.length)
      setAppliedFiltersCount(1);
    } else if (jobStatusFilterValue == 4) {
      setGigType("deleted");
      // setsearchPublish(deletedJobs)
      // setFilteredJobsCountMobile(deletedJobs?.length)

      setAppliedFiltersCount(1);
    } else if (jobStatusFilterValue == 5) {
      setGigType("closed");
      // setsearchPublish(deletedJobs)
      // setFilteredJobsCountMobile(deletedJobs?.length)

      setAppliedFiltersCount(1);
    } else {
      setsearchPublish(jobsWithOnlyCandidates);
      setFilteredJobsCountMobile(jobsWithOnlyCandidates?.length);
      setAppliedFiltersCount(1);
    }
    // addQuery ("jobStatusFilter", jobStatusFilterValue ==1 ? 'all' : jobStatusFilterValue ==2 ? 'Published' :jobStatusFilterValue ==3 ? 'expired': jobStatusFilterValue ==4 ? 'deleted':jobStatusFilterValue ==5 ? 'closed' :'all' );
    addQuery("jobStatusFilter", jobStatusFilterValue);
    setVisibleStatusDrawer(false);
    setCurrentPage(1);
  };

  const dropDownMenu = (
    <Menu style={{ width: "360px" }}>
      <div className="dropDownRowsContainer">
        <div
          style={{
            width: "100%",
            padding: "2%",
            flexDirection: "row",
            justifyContent: "center",
            display: "flex",
          }}
        >
          <Radio.Group
            style={{ width: "50%" }}
            onChange={onChangeJobStatusFilter}
            value={jobStatusFilterValue}
          >
            <Space direction="vertical" style={{ display: "flex" }}>
              <Radio className="rad-btn" value={1}>
                All
              </Radio>
              <Radio className="rad-btn" value={2}>
                Published
              </Radio>
              <Radio className="rad-btn" value={3}>
                Expired
              </Radio>
              <Radio className="rad-btn" value={4}>
                Deleted
              </Radio>
              {closedCount > 0 ? (
                <Radio className="rad-btn" value={5}>
                  Closed
                </Radio>
              ) : null}
            </Space>
          </Radio.Group>

          <div style={{ width: "50%", background: "light-blue" }}>
            <div className="rad-text">
              ({publishedCount + expiredCount + deletedCount + closedCount})
            </div>
            <div className="rad-text">({publishedCount})</div>
            <div className="rad-text">({expiredCount})</div>
            <div className="rad-text">({deletedCount})</div>
            {closedCount > 0 ? (
              <div className="rad-text">({closedCount})</div>
            ) : null}
          </div>
        </div>
        <div className="statusDropDownBtns">
          <Button
            className="clearBtnStatus"
            onClick={() => {
              setJobStatusFilterValue(1);
              // setsearchPublish(jobs.publishedGigs)
              setGigType("all");
              setVisibleDrawer(false);
              removeQuery("jobStatusFilter");
            }}
          >
            Clear
          </Button>
          <Button className="applyBtnStatus" onClick={applyFilter}>
            Apply
          </Button>
        </div>
      </div>
    </Menu>
  );

  const onCloseStatusDrawer = () => {
    setVisibleStatusDrawer(false);
  };

  const onChangePage = (page) => {
    handleApplyFilter({ ...(searchFilters || {}), page });
    setCurrentPage(page);
  };

  const onChangePageDraft = (page) => {
    setCurrentPageDraft(page);
    getDrafts(DraftInputSearch, page);
  };

  const onChangejobsWithOnlyCandidate = () => {
    if (jobsWithOnlyCandidatesValue) {
      setJobsWithOnlyCandidatesValue(false);
      setsearchPublish(jobs.publishedGigs);
      setJobStatusFilterValue(1);
    } else {
      setJobsWithOnlyCandidatesValue(true);
      setsearchPublish(jobsWithOnlyCandidates);
    }
  };

  window.scrollTo(0, 0);

  const menu = (
    <Menu onClick={onClick} className="filterDropDownText-menu">
      <Menu.Item key="most_recent" style={{ fontSize: "18px" }}>
        Most recent
      </Menu.Item>
      <Menu.Item key="upcoming_expiry">Upcoming expiry</Menu.Item>
      {/* <Menu.Item key="candidate_high_to_low">Candidate high to low</Menu.Item>
      <Menu.Item key="candidate_low_to_high">Candidate low to high</Menu.Item> */}
    </Menu>
  );

  // 500 on not deleted
  // 200 on deleted

  const handleSearch = _.debounce((value) => {
    handleApplyFilter({ ...searchFilters, all: value, search: value });
    updateFilters({ ...searchFilters, all: value, search: value });
  }, 600);

  const updateFilters = (data) => {
    const params = {
      value: "",
      body: {
        isPrivateGig: false,
        ...data,
        MygigsProfileId:  userProfile?.MasterAccountId || userProfile?.AccountId,
      },
    };
    setCurrentPage(1);
    dispatch(keySearchMyGigsLocation(params));
    dispatch(fetchMyGigsKeySearchSkills(params));
    // dispatch(GetMyGigFilters(params));
    // dispatch(getJobCounts(params));
  };

  const handleApplyFilter = (filters = {}) => {
    try {
      const {
        all,
        cities,
        countries,
        regions,
        Skills,
        explevel,
        isPrivateGig,
        JobOrderTypeName,
        JobOrderStatusName,
        _sort,
        page,
      } = filters;
      getGigs({
        variables: {
          all: all || "",
          cities: cities?.length ? cities : undefined,
          countries: countries?.length ? countries : undefined,
          regions: regions?.length ? regions : undefined,
          Skills: Skills?.length ? Skills : undefined,
          isPrivateGig,
          MygigsProfileId:userProfile?.MasterAccountId || userProfile?.AccountId,
          _page: page || "1",
          _perPage: pageSize,
          _sort: _sort || "MOST_RECENT",
          explevel: explevel || undefined,
          JobOrderTypeName: JobOrderTypeName || undefined,
          JobOrderStatusName: JobOrderStatusName || "All",
          // ...(getAbsParams() || {}),
        },
      });
    } catch (error) {
      console.warn("error", error);
    }
  };

  return jobs?.length === 0 ? (
    <Loader />
  ) : (
    <>
      <Drawer
        onClose={onCloseStatusDrawer}
        open={visibleStatusDrawer}
        placement="top"
        height="520px"
        closable={false}
        title={
          <div>
            <Row>
              <Col
                xs={5}
                className={"clearAll"}
                onClick={() => {
                  setAppliedFiltersCount(0);
                  setJobStatusFilterValue(0);
                  setsearchPublish(jobs.publishedGigs);
                  setJobStatusFilterValue(1);
                  setVisibleStatusDrawer(false);
                  removeQuery("jobStatusFilter");
                }}
              >
                Clear all
              </Col>
              <Col xs={17} className={"filter-text"}>
                Filter
              </Col>
              <Col
                xs={2}
                className={"close-text"}
                onClick={onCloseStatusDrawer}
              >
                <CloseOutlined style={{ color: "#9e9e9e" }} />
              </Col>
            </Row>
          </div>
        }
      >
        <>
          <div className="jobStatusDropDownText">Gig status</div>
          <Radio.Group
            style={{ width: "100%" }}
            onChange={onChangeJobStatusFilter}
            value={jobStatusFilterValue}
          >
            <Space direction="vertical" style={{ display: "flex" }}>
              <>
                <Radio className="radio-btnss" value={1}>
                  All
                </Radio>
                <Radio className="radio-btnss" value={2}>
                  Published
                </Radio>
                <Radio className="radio-btnss" value={3}>
                  Expired
                </Radio>
                <Radio className="radio-btnss" value={4}>
                  Deleted
                </Radio>
                <Radio className="radio-btnss" value={5}>
                  Closed
                </Radio>
              </>
              {/* <>
                <Radio
                  style={{ marginTop: '1%', marginBottom: '3%' }}
                  value={6}
                >
                  Show gigs only with candidates
                </Radio>
              </> */}
            </Space>
          </Radio.Group>
          <Divider style={{ marginTop: "0px" }} />
          <button onClick={applyFilter} className={"applyFilterDrawer-btn"}>
            Apply filter
          </button>
        </>
      </Drawer>
      <Col
        className="jobListing"
        span={24}
        style={{ marginTop: dimensions > 769 ? "6rem" : "7.7rem" }}
      >
        {/* <Col style={{ padding: "10px 2px 10px 2px", background:'red' }}> */}
        {deljobsuccess && delete_job_response.status == 200 ? (
          <TopAlert
            display={"flex"}
            title={"Gig successfully deleted"}
            type="success"
          />
        ) : null}
        {/* 
        {deljobsuccess && delete_job_response.status == 500 ? (
          <TopAlert
            display={"flex"}
            title={delete_job_response?.message}
            //  title={'You can’t delete this job since you have active bids and interviews associated with this gig'}
            type="warning"
          />
        ) : null} */}

        {/* {expiry_response ? (
          <TopAlert
            display={"flex"}
            title={"Gig expiry extended successfully"}
            type="success"
          />
        ) : null} */}

        <Row
          style={{
            display: "flex",
            justifyContent: "space-between",
            marginLeft: "2%",
            marginRight: "2%",
          }}
        >
          <div className="joblisting-myjobs">My Gigs</div>
          <div
            style={{
              width: "209px",
              display: "flex",
              alignItems: "flex-start",
              justifyContent: "flex-end",
            }}
          >
            <button
              className={
                dimensions > 769 ? "joblisting-btn" : "joblisting-btn-mobile"
              }
              //className={"joblisting-btn"}
              onClick={() => history.push("/postjob")}
            >
              + &nbsp;Post a gig
            </button>
          </div>
        </Row>

        <div className="jobListingTabs">
          <Tabs
            className="top_tabs_jobs"
            defaultActiveKey="Published"
            onChange={handleTabChange}
            tabBarGutter={23}
            tabBarStyle={{ marginLeft: "2%", marginRight: "2%" }}
          >
            <TabPane
              tab={`All gigs
              `}
              key="Published"
            >
              <Row style={{ marginLeft: "2%", marginRight: "2%" }}>
                <div style={{ width: dimensions < 769 && "75.8%" }}>
                  <Input
                    className={
                      dimensions > 769
                        ? "joblisting-inp"
                        : "joblisting-inp-mobile"
                    }
                    type="input"
                    placeholder="Find gig(s)"
                    prefix={
                      <SearchOutlined className="joblisting-searchicon" />
                    }
                    onChange={(e) => searchHandler(e.target.value)}
                    allowClear
                  />
                </div>
              </Row>
              {tabType == "Published" && (
                <AllGigsFilter
                  searchText={inputSearch}
                  handleApplyFilter={handleApplyFilter}
                  windowDimensions={windowDimensions}
                  searchFilters={searchFilters}
                  setSearchFilters={setSearchFilters}
                  webPadding={"10px 30px"}
                  tagPadding="0px 10px 0px 30px"
                  mobileButtonsPadding={"5px 4px 0px 8px"}
                  showGigStaus={true}
                />
              )}

              {loadingGigs ? (
                <Loader />
              ) : searchPublishGigs == 0 ? (
                <div
                  className={`noJobsContainer ${
                    MostRecentJobs?.length > 0 &&
                    searchPublishGigs.length === 0 &&
                    "noJobsContainer-remove-space"
                  }`}
                >
                  <img
                    src={emptyresult}
                    alt="no-jobsimg"
                    className="joblisting-noimg jobListing-icon-size"
                  ></img>
                  <div className="joblisting-Text-NoData-Card">
                    {MostRecentJobs?.length > 0 &&
                    (jobs?.publishedGigs?.length > 0 ||
                      inputSearch?.length > 0) ? (
                      <>
                        <div className="joblisting-Text-NoData">
                          {" "}
                          No results for{" "}
                          <span className="jobListing-text-bold">
                            "{inputSearch}"
                          </span>
                        </div>
                        <div className="Joblisting-recent-gigs-Cantainer">
                          <div className="Joblisting-recent-gigs">
                            Your recent gigs
                          </div>
                          <Row gutter={[16, 16]}>
                            {MostRecentJobs.length &&
                              MostRecentJobs.map((item) => {
                                return (
                                  <Col
                                    xs={24}
                                    sm={24}
                                    lg={8}
                                    xl={8}
                                    style={{ height: "auto" }}
                                  >
                                    <div className="jobcard-container">
                                      <JobCard
                                        {...(item || {})}
                                        jobdetails={[item]}
                                        fromDashboard={false}
                                        Skills={item?.JobOrders_Skills}
                                        Industry={item.Industry}
                                        description={item.Description}
                                        professionCode={
                                          userProfile?.Professions
                                            ?.ProfessionCode
                                        }
                                        workauthorization={
                                          item.WorkAuthorization
                                        }
                                        isTemplate={item.isTemplate}
                                        screen="My Gigs"
                                        BudgetMin={Math.floor(item.BudgetMin)}
                                        key={item._id}
                                        img={
                                          item?.Regions?.Code !== null &&
                                          item?.Cities?.CityName !== null
                                            ? getImageByStateCode(
                                                item?.Regions?.Code,
                                                item?.Cities?.CityName,
                                                item?.CompanyName
                                              )
                                            : candidate_img
                                        }
                                        RegionCode={item?.Regions?.Code}
                                        CityName={item?.Cities?.CityName}
                                        id={item?.JobOrderId}
                                        location={`${item?.Cities?.CityName}, ${item?.Regions?.Code}`}
                                        title={item.Title}
                                        experience={item.ExperienceLevels}
                                        facilityRating={item.facilityRating}
                                        facilityname={item.FacilityName}
                                        employerName={item.EmployerName}
                                        budget={item.BudgetMin}
                                        rates={
                                          item?.BudgetTypes?.BudgetTypeName
                                        }
                                        budgetType={
                                          item?.BudgetTypes?.BudgetTypeCode
                                        }
                                        placedbids={item.status[0].count}
                                        matchedbids={item.status[2].count}
                                        receivedbids={item.status[1].count}
                                        candidates={item.status[3].count}
                                        cardFooter={true}
                                        WorkplacePolicy={item.WorkplacePolicy}
                                        isDeleted={
                                          item?.JobOrderStatuses
                                            ?.JobOrderStatusName == "Deleted"
                                            ? true
                                            : false
                                        }
                                        indeleted={
                                          item?.JobOrderStatuses
                                            ?.JobOrderStatusName == "Deleted"
                                            ? true
                                            : false
                                        }
                                        expired={
                                          item?.JobOrderStatuses
                                            ?.JobOrderStatusName == "Expired"
                                            ? true
                                            : false
                                        }
                                        closed={
                                          item?.JobOrderStatuses
                                            ?.JobOrderStatusName == "Closed"
                                            ? true
                                            : false
                                        }
                                        JobOrderStatusName={
                                          item?.JobOrderStatuses
                                            ?.JobOrderStatusName
                                        }
                                        IdealContractLengthName={
                                          item?.IdealContractLength
                                            ?.IdealContractLengthName
                                        }
                                        RoleName={item?.Role}
                                        jobOrderType={
                                          item?.JobOrderTypes?.JobOrderTypeName
                                        }
                                        certificates={item?.Certifications}
                                        expiryDate={item.ExpiryDate}
                                        from={"ManageGigs"}
                                        JobOrderId={item?.JobOrderId}
                                        openPositions={item?.Position}
                                        rating={item?.facilityRating?.rating}
                                        isPrivate={item?.isPrivate}
                                        showAI={true}
                                      />
                                    </div>
                                  </Col>
                                );
                              })}
                          </Row>
                        </div>
                      </>
                    ) : (
                      <div className="joblisting-Text-NoData">
                        <div>No data - Post your first gig</div>
                        <div className="PostgigButton">{postgigs}</div>
                      </div>
                    )}
                  </div>
                </div>
              ) : (
                <div
                  style={{
                    marginLeft: "2%",
                    marginRight: "2%",
                    marginTop: "1%",
                    marginBottom: "3%",
                  }}
                >
                  <Row gutter={[16, 16]}>
                    {searchPublishGigs.length &&
                      searchPublishGigs.map((item, index) => {
                        return (
                          <Col
                            xs={24}
                            sm={24}
                            lg={8}
                            xl={8}
                            style={{ height: "auto" }}
                          >
                            <div className="jobcard-container">
                              <JobCard
                                {...item}
                                // expiryDate = {item.ExpiryDate}
                                jobdetails={[item]}
                                fromDashboard={false}
                                Skills={item?.JobOrders_Skills}
                                Industry={item.Industry}
                                description={item.Description}
                                professionCode={
                                  userProfile?.Professions?.ProfessionCode
                                }
                                workauthorization={item.WorkAuthorization}
                                isTemplate={item.isTemplate}
                                screen="My Gigs"
                                BudgetMin={Math.floor(item.BudgetMin)}
                                key={item._id}
                                img={
                                  // item.Location?.RegionCode !== null &&
                                  //   item.Location?.CityName !== null
                                  //   ? getImageByStateCode(
                                  //     item.Location?.RegionCode,
                                  //     item.Location?.CityName
                                  item?.Regions?.Code !== null &&
                                  item?.Cities?.CityName !== null &&
                                  item?.CompanyName !== null
                                    ? getImageByStateCode(
                                        item?.Regions?.Code,
                                        // 'item?.Regions?.Code',
                                        item?.Cities?.CityName,
                                        item?.CompanyName
                                        // 'state',
                                      )
                                    : candidate_img
                                }
                                RegionCode={item?.Regions?.Code}
                                CityName={item?.Cities?.CityName}
                                id={item?.JobOrderId}
                                location={`${item?.Cities?.CityName}, ${item?.Regions?.Code}`}
                                title={item?.Title ?? null}
                                experience={item.ExperienceLevels}
                                facilityRating={item.facilityRating}
                                facilityname={item.FacilityName}
                                employerName={item.EmployerName}
                                budget={item.BudgetMin}
                                rates={item?.BudgetTypes?.BudgetTypeName}
                                budgetType={item?.BudgetTypes?.BudgetTypeCode}
                                placedbids={item.status[0]?.count}
                                matchedbids={item.status[2]?.count}
                                receivedbids={item.status[1]?.count}
                                candidates={item.status[3]?.count}
                                cardFooter={true}
                                WorkplacePolicy={item.WorkplacePolicy}
                                isDeleted={
                                  item?.JobOrderStatuses?.JobOrderStatusName ==
                                  "Deleted"
                                    ? true
                                    : false
                                }
                                indeleted={
                                  item?.JobOrderStatuses?.JobOrderStatusName ==
                                  "Deleted"
                                    ? true
                                    : false
                                }
                                expired={
                                  item?.JobOrderStatuses?.JobOrderStatusName ==
                                  "Expired"
                                    ? true
                                    : false
                                }
                                closed={
                                  item?.JobOrderStatuses?.JobOrderStatusName ==
                                  "Closed"
                                    ? true
                                    : false
                                }
                                JobOrderStatusName={
                                  item?.JobOrderStatuses?.JobOrderStatusName
                                }
                                IdealContractLengthName={
                                  item?.IdealContractLength
                                    ?.IdealContractLengthName
                                }
                                RoleName={item?.Role}
                                jobOrderType={
                                  item?.JobOrderTypes?.JobOrderTypeName
                                }
                                certificates={item?.Certifications}
                                expiryDate={item.ExpiryDate}
                                //gigId={item.GigId}
                                from={"ManageGigs"}
                                JobOrderId={item?.JobOrderId}
                                openPositions={item?.Position}
                                rating={item?.facilityRating?.rating}
                                isPrivate={item?.isPrivate}
                                reviews={item?.facilityRating?.reviews}
                                created={item?.Created}
                                isPrivateGig={
                                  item?.myjobs?.gigs[0]?.isPrivate || false
                                }
                                showAI={true}
                              />
                            </div>
                          </Col>
                        );
                      })}
                  </Row>
                </div>
              )}
              {inputSearch == "" ? (
                // (jobs?.publishedGigs && publishedCount + expiredCount + deletedCount > 20) &&
                <Pagination
                  style={{
                    display: "flex",
                    justifyContent: "center",
                    marginTop: "20px",
                  }}
                  total={data?.gigs?.aggregate?.totalCount || 0}
                  current={currentPage}
                  defaultPageSize={pageSize}
                  onChange={(page) => {
                    removeQuery("all_gigs_page");
                    onChangePage(page);
                    addQuery("all_gigs_page", page);
                  }}
                  showSizeChanger={false}
                  hideOnSinglePage={true}
                />
              ) : null}
            </TabPane>
            <TabPane tab={`Draft`} key="Draft">
              <Row style={{ marginLeft: "2%", marginRight: "2%" }}>
                <Col span={24}>
                  <Input
                    className={
                      dimensions > 769
                        ? "joblisting-inp"
                        : "joblisting-inp-mobile"
                    }
                    type="input"
                    placeholder="Find gig(s)"
                    prefix={
                      <SearchOutlined className="joblisting-searchicon" />
                    }
                    // style={{ marginTop: '2px' }}
                    onChange={(e) => searchDraftHandler(e.target.value)}
                    allowClear
                  />
                </Col>

                {/* <Col span={4}>
                    <Row>
                      {dimensions < 769 ? (
                        <Dropdown overlay={menu}
                          trigger={['click']}>
                          <BsSortUpAlt className="joblisting-sorticon" />
                        </Dropdown>
                      ) : null}

                    </Row>
                  </Col> */}
              </Row>

              {loadingGigs ? (
                <Loader />
              ) : searchPublishGigs?.length == 0 ? (
                <div
                  className={`noJobsContainer ${
                    searchDraft?.length > 0 &&
                    searchDraft.length === 0 &&
                    "noJobsContainer-remove-space"
                  }`}
                >
                  <img
                    src={emptyresult}
                    alt="no-jobsimg"
                    className="joblisting-noimg jobListing-icon-size"
                  ></img>
                  <div className="joblisting-Text-NoData-Card">
                    {MostRecentDraft?.draftGigs?.length > 0 &&
                    DraftInputSearch?.length > 0 ? (
                      <>
                        <div className="joblisting-Text-NoData">
                          {" "}
                          No results for{" "}
                          <span className="jobListing-text-bold">
                            "{DraftInputSearch}"
                          </span>
                        </div>
                        <div className="Joblisting-recent-gigs-Cantainer">
                          <div className="Joblisting-recent-gigs">
                            Your recent gigs
                          </div>
                          <Row gutter={[16, 16]}>
                            {MostRecentDraft?.draftGigs?.length &&
                              MostRecentDraft?.draftGigs
                                ?.slice(0, 3)
                                ?.map((item) => {
                                  return (
                                    <Col
                                      xs={24}
                                      sm={24}
                                      lg={8}
                                      xl={8}
                                      style={{ height: "auto" }}
                                    >
                                      <div className="jobcard-container">
                                        <JobCard
                                          {...item}
                                          jobdetails={[item]}
                                          fromDashboard={false}
                                          Skills={item?.JobOrders_Skills}
                                          Industry={item.Industry}
                                          description={item.Description}
                                          professionCode={
                                            userProfile?.Professions
                                              ?.ProfessionCode
                                          }
                                          workauthorization={
                                            item.WorkAuthorization
                                          }
                                          isTemplate={item.isTemplate}
                                          screen="My Gigs"
                                          BudgetMin={Math.floor(item.BudgetMin)}
                                          key={item._id}
                                          img={
                                            item?.Regions?.Code !== null &&
                                            item?.Cities?.CityName !== null
                                              ? getImageByStateCode(
                                                  item?.Regions?.Code,
                                                  item?.Cities?.CityName,
                                                  item?.CompanyName
                                                )
                                              : candidate_img
                                          }
                                          RegionCode={item?.Regions?.Code}
                                          CityName={item?.Cities?.CityName}
                                          id={item?.JobOrderId}
                                          location={`${item?.Cities?.CityName}, ${item?.Regions?.Code}`}
                                          title={item.Title}
                                          experience={item.ExperienceLevels}
                                          facilityRating={item.facilityRating}
                                          facilityname={item.FacilityName}
                                          employerName={item.EmployerName}
                                          budget={item.BudgetMin}
                                          rates={
                                            item?.BudgetTypes?.BudgetTypeName
                                          }
                                          budgetType={
                                            item?.BudgetTypes?.BudgetTypeCode
                                          }
                                          placedbids={item.status[0].count}
                                          matchedbids={item.status[2].count}
                                          receivedbids={item.status[1].count}
                                          candidates={item.status[3].count}
                                          cardFooter={true}
                                          WorkplacePolicy={item.WorkplacePolicy}
                                          isDeleted={
                                            item?.JobOrderStatuses
                                              ?.JobOrderStatusName == "Deleted"
                                              ? true
                                              : false
                                          }
                                          indeleted={
                                            item?.JobOrderStatuses
                                              ?.JobOrderStatusName == "Deleted"
                                              ? true
                                              : false
                                          }
                                          expired={
                                            item?.JobOrderStatuses
                                              ?.JobOrderStatusName == "Expired"
                                              ? true
                                              : false
                                          }
                                          closed={
                                            item?.JobOrderStatuses
                                              ?.JobOrderStatusName == "Closed"
                                              ? true
                                              : false
                                          }
                                          JobOrderStatusName={
                                            item?.JobOrderStatuses
                                              ?.JobOrderStatusName
                                          }
                                          IdealContractLengthName={
                                            item?.IdealContractLength
                                              ?.IdealContractLengthName
                                          }
                                          RoleName={item?.Role}
                                          jobOrderType={
                                            item?.JobOrderTypes
                                              ?.JobOrderTypeName
                                          }
                                          certificates={item?.Certifications}
                                          expiryDate={item.ExpiryDate}
                                          from={"ManageGigs"}
                                          JobOrderId={item?.JobOrderId}
                                          openPositions={item?.Position}
                                          rating={item?.facilityRating?.rating}
                                          isPrivate={item?.isPrivate}
                                          showAI={true}
                                        />
                                      </div>
                                    </Col>
                                  );
                                })}
                          </Row>
                        </div>
                      </>
                    ) : (
                      <div className="joblisting-Text-NoData">
                        <div>No data</div>
                        {/* <div className="PostgigButton" >{postgigs}</div> */}
                      </div>
                    )}
                  </div>
                </div>
              ) : (
                <div
                  style={{
                    marginLeft: "2%",
                    marginRight: "2%",
                    marginTop: "1%",
                    marginBottom: "3%",
                  }}
                >
                  <Row gutter={[16, 16]}>
                    {searchPublishGigs?.length != 0
                      ? searchPublishGigs?.length &&
                        searchPublishGigs?.map((item, index) => {
                          return (
                            // <div style={{ margin: "2%" ,background: 'pink'}} >
                            <Col key={index} xs={24} sm={24} lg={8} xl={8}>
                              <div className="jobcard-container">
                                <JobCard
                                  {...item}
                                  Skills={item?.JobOrders_Skills}
                                  Industry={item.Industry}
                                  description={item.Description}
                                  key={item._id}
                                  img={
                                    // item.Location?.RegionCode !== null &&
                                    //   item.Location?.CityName !== null
                                    //   ? getImageByStateCode(
                                    //     item.Location?.RegionCode,
                                    //     item.Location?.CityName
                                    //   )
                                    item?.Regions?.Code !== null &&
                                    item?.Cities?.CityName !== null
                                      ? getImageByStateCode(
                                          item?.Regions?.Code,
                                          item?.Cities?.CityName
                                        )
                                      : candidate_img
                                  }
                                  RegionCode={item?.Regions?.Code}
                                  CityName={item?.Cities?.CityName}
                                  professionCode={
                                    userProfile?.Professions?.ProfessionCode
                                  }
                                  title={item?.Title}
                                  location={`${item?.Cities?.CityName}, ${item?.Regions?.Code}`}
                                  // id={item._id}
                                  id={item?.JobOrderId}
                                  screen="JMy Gigs"
                                  facilityname={item.FacilityName}
                                  budget={item.BudgetMin}
                                  // rates={item?.BudgetTypes?.BudgetTypeName}
                                  rates={item?.BudgetTypes?.BudgetTypeName}
                                  budgetType={item?.BudgetTypes?.BudgetTypeCode}
                                  placedbids={item.status?.[0]?.count}
                                  matchedbids={item.status?.[2]?.count}
                                  receivedbids={item.status?.[1]?.count}
                                  candidates={item.status?.[3]?.count}
                                  experience={item.ExperienceLevels}
                                  indraft={true}
                                  isDeleted={
                                    item.JobOrderStatusName == "Deleted"
                                      ? true
                                      : false
                                  }
                                  cardFooter={true}
                                  // IdealContractLengthName={item.IdealContractLengthName}
                                  // RoleName={item.GigSkillListingRole.length > 0 && item.GigSkillListingRole[0].RoleName}
                                  IdealContractLengthName={
                                    item?.IdealContractLength
                                      ?.IdealContractLengthName
                                  }
                                  RoleName={item?.Role}
                                  jobOrderType={
                                    item?.JobOrderTypes?.JobOrderTypeName
                                  }
                                  fromJobListingPage={true}
                                  certificates={item?.Certifications}
                                  // WorkplacePolicy={item?.WorkplacePolicy}
                                  WorkplacePolicy={item?.WorkplacePolicy}
                                  //indeleted={true}
                                  // gigId={item.GigId}
                                  from={"ManageGigs"}
                                  openPositions={item?.Position}
                                  rating={item?.facilityRating?.rating}
                                  created={item?.Created}
                                  isPrivate={item?.isPrivate}
                                  showAI={true}
                                />
                              </div>
                            </Col>
                          );
                        })
                      : null}
                  </Row>
                </div>
              )}
              <Pagination
                style={{
                  display: "flex",
                  justifyContent: "center",
                  marginTop: "20px",
                }}
                total={data?.gigs?.aggregate?.totalCount || 0}
                current={currentPageDraft}
                defaultPageSize={pageSize}
                onChange={(page) => {
                  removeQuery("draft_gigs_page");
                  onChangePageDraft(page);
                  addQuery("draft_gigs_page", page);
                }}
                showSizeChanger={false}
                hideOnSinglePage={true}
              />
            </TabPane>
          </Tabs>
        </div>
      </Col>
    </>
  );
}

const ApolloWrapper = (props) => {
  const BackendApiBaseUrl = process.env.REACT_APP_API_URL;

  const authTokenValue = useSelector(
    (state) => state.authReducer.user.authToken
  );
  const userProfile = JSON.parse(localStorage.getItem("userProfile"));
  const ImpersonationId = useSelector(
    (state) => state.authReducer.impersonationId
  );

  const httpLink = new HttpLink({
    uri: `${BackendApiBaseUrl}/query`,
  });

  const authLink = setContext((_, { headers }) => {
    if (ImpersonationId) {
      return {
        headers: {
          ...headers,
          authorization: authTokenValue ? `${authTokenValue}` : "",
          email: userProfile?.EmailAddress,
          impersonationid: ImpersonationId,
        },
      };
    } else {
      return {
        headers: {
          ...headers,
          authorization: authTokenValue ? `${authTokenValue}` : "",
          email: userProfile?.EmailAddress,
        },
      };
    }
  });

  const client = new ApolloClient({
    cache: new InMemoryCache(),
    link: authLink.concat(httpLink),
    defaultOptions: {
      watchQuery: {
        nextFetchPolicy: "no-cache",
      },
    },
  });

  return (
    <ApolloProvider client={client}>
      <JobListing {...props} />
    </ApolloProvider>
  );
};

export default ApolloWrapper;
